import type { IntlShape } from 'react-intl';

import { Context } from 'effect';

// Key string kept byte-identical to the app's former `ContextTag.IntlContext`
// registry entry (ENGINE_MOVE.md §5 — key strings must not change when a
// service moves; per-tag registry dissolution is the sanctioned option (c)).
export class IntlContext extends Context.Service<
  IntlContext,
  {
    intl: IntlShape;
  }
>()('@app/IntlContext') {}
